import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = (theme: Theme) => createStyles({
  statsItem: {
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '22px',
    marginTop: '1.6875em',
    marginBottom: '1.5em',
    paddingLeft: '0.625em',
    paddingRight: '0.625em',
    '& > div:first-child': {
      color: theme.palette.secondary.main,
      fontSize: '3.5em',
      fontWeight: 'bold',
      marginBottom: '0.25em',
      letterSpacing: '0.0359em',
      lineHeight: 0.8214
    }
  }
});

interface StatsItemProps {
  count?: number;
  text: string;
}

const InfoListItem: React.SFC<WithStyles & StatsItemProps> = ({
  classes,
  count,
  text
}) => {
  return (
    <Grid item xs={12} sm={6} md container direction="column" className={classes.statsItem}>
      <Grid item>{count || <br />}</Grid>
      <Grid item>{text}</Grid>
    </Grid>
  );
}

export default withStyles(styles)(InfoListItem);



// WEBPACK FOOTER //
// ./src/landingPage/components/StatsItem.tsx